import { gaiaKey, logoffUrl as baseUrl, requestJson, LOGOFF_FAIL_CODE } from './config'
import { getConstId, handleResponse } from './utils'
import { myAxios } from '../utils'
const checkAccountUrl = `${baseUrl}/check` // 查询当前账户是否可以注销
const sendSmsCodeUrl = `${baseUrl}/send` // 短验方式注销-请求短信验证码
const reasonListUrl = `${baseUrl}/getReasonList` // 查询注销的原因
const submitSmsUrl = `${baseUrl}/sms` // 短验方式注销-填写验证码

/*
* 注销-查询当前账户是否可以注销
*  */
export const checkAccountState = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(checkAccountUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res, [LOGOFF_FAIL_CODE])
    })
}

/*
* 注销-短验方式注销-获取短信验证码
*  */
export const sendSmsCode = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(sendSmsCodeUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}

/*
* 注销-短验方式注销-提交手机验证码
*  */
export const submitSms = async (params) => {
  const fingerprint = await getConstId()
  let paramsData = {
    ...await requestJson(),
    ...params
  }
  if (fingerprint) {
    paramsData.fingerprint = fingerprint
  }
  return myAxios.post(submitSmsUrl, paramsData, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}

/*
* 注销-获取注销原因
*  */
export const getReasonList = (params) => {
  return myAxios.get(reasonListUrl, {
    headers: {
      'X-GAIA-API-KEY': gaiaKey
    }
  })
    .then((res) => {
      return handleResponse(res)
    })
}
